export default "__VITE_ASSET__6eed9f78__"